import style from '../styles/SubmitButton.module.scss'

export default function SubmitButton({ id, text, onClick }) {

    return (
        <>
            <div className={style.button}>
                <p>{text}</p>
                <input id={id} type="checkbox" onChange={onClick}/>
            </div>
        </>
    )
}